import { ApiAxiosInstance } from '../instances/apiAxiosInstance';

//TYPES
import { type ShippingOtp } from '@/shared/otp';
import { CardMovement } from '@/types/CardMovement';
import { CardMovementParamsTypes } from "@/api/types/card/CardMovementParamsTypes";
import { ICard, ICardData, ITermsCard, ITermsCardCheck, ICardAmountExchange, CardRenewalResponse, ICardCartola, ICardCartolaParams, CardLimitInfo } from '@/types/card';
import { CardRenewalPayload } from '@/modules/card';

interface ICardDetailParams {
  authvalue: string;
  cardId: number;
}

export const cardClient = {
  /**
   * @deprecated Usar cardService.createCard() de src/modules/card/services/card.service.ts
   */
  createCard(authValue?: string) {
    return ApiAxiosInstance.post<ICard>('card/b2b/create', {}, {
      headers: {
        authType: 'PIN',
        authValue,
      }
    });
  },
  /**
   * @deprecated Usar cardService.deleteCard() de src/modules/card/services/card.service.ts
   */
  deleteCard(id: number, authvalue: string) {
    return ApiAxiosInstance.delete('card/b2b', {
      data: { cardId: id },
      headers: {
        authvalue,
        authType: 'PIN',
      },
    })
  },
  /**
   * @deprecated Usar cardService.getCards() de src/modules/card/services/card.service.ts
   */
  getCards(listAccountIds: number[]) {
    return ApiAxiosInstance.post<ICard[]>('card/b2b', {
      listAccountIds,
    })
  },
  /**
   * @deprecated Usar cardService.getCardLimit() de src/modules/card/services/card.service.ts
   */
  getCardIssueLimit() {
    return ApiAxiosInstance.get<CardLimitInfo>('card/b2b/limit')
  },
  /**
   * @deprecated Usar cardService.getCardDetail() de src/modules/card/services/card.service.ts
   */
  getCardDetail(payload: ICardDetailParams) {
    return ApiAxiosInstance.get<ICardData>('card/b2b', {
      headers: {
        authtype: 'PIN',
        authvalue: payload.authvalue,
      },
      params: {
        cardId: payload.cardId,
      }
    })
  },
  /**
   * @deprecated Usar cardService.updateCardLock() de src/modules/card/services/card.service.ts
   */
  lockCard(cardId: number) {
    return ApiAxiosInstance.post<ShippingOtp>('card/b2b/lock', {
      cardId,
    })
  },
  /**
   * @deprecated Usar cardService.updateCardUnlock() de src/modules/card/services/card.service.ts
   */
  unlockCard(cardId: number) {
    return ApiAxiosInstance.post<ShippingOtp>('card/b2b/unlock', {
      cardId,
    })
  },
  /**
   * @deprecated Usar cardService.updateCardRenewal() de src/modules/card/services/card.service.ts
   */
  checkAndRenewCard(payload: CardRenewalPayload) {
    return ApiAxiosInstance.post<CardRenewalResponse>('card/b2b/reprint', payload)
  },
  /**
   * @deprecated Usar cardService.getCardExchangeRates() de src/modules/card/services/card.service.ts
   */
  getCardExchangeRates(accountId: number) {
    return ApiAxiosInstance.get<ICardAmountExchange>(`card/b2b/exchange-rates/balance/${accountId}`)
  },
  /**
   * @deprecated Usar termsService.getTermsAndConditions() de @/shared/common/services
   */
  getTermsAndConditions() {
    return ApiAxiosInstance.get<ITermsCard[]>(`card/b2b/terms-and-conditions`)
  },
  /**
   * @deprecated Usar termsService.updateTermsAcceptance() de @/shared/common/services
   */
  confirmTermsAndConditions(migration = false) {
    return ApiAxiosInstance.post<void>(`card/b2b/terms-and-conditions/accept`, {
      migration
    })
  },
  /**
   * @deprecated Usar termsService.getTermsAcceptanceStatus() de @/shared/common/services
   */
  checkTermsAndConditions() {
    return ApiAxiosInstance.get<ITermsCardCheck>(`card/b2b/terms-and-conditions/accept`)
  },
  /**
   * @deprecated Usar cardService.getCardMovements() de src/modules/card/services/card.service.ts
   */
  getCardMovements(params: CardMovementParamsTypes) {
    return ApiAxiosInstance.get<CardMovement[]>(`card/b2b/movements/${params.accountId}`, {
      params
    })
  },
  /**
   * @deprecated Usar cardService.getCardStatement() de src/modules/card/services/card.service.ts
   */
  getCardCartola(params: ICardCartolaParams) {
    return ApiAxiosInstance.get<ICardCartola>('document/b2b/bank-statement', {
      params
    })
  },
};
